import type { ReactNode } from "react";

export function ChatBubble({
  role,
  children,
}: {
  role: "user" | "ai";
  children: ReactNode;
}) {
  if (role === "user") {
    return (
      <div className="self-end max-w-[82%] bg-ink-900 text-on-dark-bright text-[13px] px-3 py-2 rounded-[13px_13px_3px_13px]">
        {children}
      </div>
    );
  }
  return (
    <div className="self-start max-w-[86%] bg-white border border-border-default text-[13px] text-[#2A342E] px-3 py-2 rounded-[13px_13px_13px_3px]">
      {children}
    </div>
  );
}
